import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import EditButton from '../../../shared/actionButtons/EditButton'
import OverviewModal from './EditModals/OverviewModal'

type Props = {}

function BasicInfo({}: Props) {
  const [overviewModal, setoverviewModal] = useState(false)
  const handleoverviewModal = () => {
    setoverviewModal(!overviewModal)
  }

  return (
    <div className='card-body pt-9 pb-0'>
      <OverviewModal editModal={overviewModal} handleEditModal={handleoverviewModal} />
      <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
        <div className='me-7 mb-4'>
          <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
            <img src={toAbsoluteUrl('/media/avatars/300-1.jpg')} alt='Metornic' />
          </div>
        </div>

        <div className='flex-grow-1'>
          <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
            <div className='d-flex flex-column'>
              <div className='d-flex d-column align-items-center '>
                <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                  Max Smith
                </a>
                <EditButton handleEditModal={handleoverviewModal} className='mx-3' />
              </div>
              <Link to='#' className='fs-6  text-primary mb-2  pe-2'>
                @username
              </Link>
              <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                <a
                  href='#'
                  className='d-flex align-items-center text-gray-400 text-hover-primary mb-2 me-5'
                >
                  <KTSVG
                    path='/media/icons/duotune/communication/com011.svg'
                    className='svg-icon-4 me-1'
                  />
                  max@gmail.com
                </a>
                <a
                  href='#'
                  className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                >
                  <KTSVG path='/media/svg/misc/smartphone.svg' className='svg-icon-4 me-1' />
                  0912345678
                </a>
                <a
                  href='#'
                  className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen018.svg'
                    className='svg-icon-4 me-1'
                  />
                  SF, Bay Area
                </a>
              </div>
            </div>

            <div className='d-flex my-4'>
              <span className='badge badge-light-success py-3 px-4 fw-bold'>ACTIVE</span>
            </div>
          </div>

          <div className='d-flex flex-wrap flex-stack'>
            <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
              <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                <span className='fw-bold fs-6 text-gray-400'>Profile Compleation</span>
                <span className='fw-bolder fs-6'>50%</span>
              </div>
              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                <div
                  className='bg-success rounded h-5px'
                  role='progressbar'
                  style={{width: '50%'}}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BasicInfo
